import { render, staticRenderFns } from "./ClientEmails.vue?vue&type=template&id=07e52712&scoped=true&"
import script from "./ClientEmails.vue?vue&type=script&lang=js&"
export * from "./ClientEmails.vue?vue&type=script&lang=js&"
import style0 from "./ClientEmails.vue?vue&type=style&index=0&id=07e52712&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07e52712",
  null
  
)

export default component.exports